export default "__VITE_ASSET__a6486947__"